import { Mail, Loader2, CheckCircle2, LogOut } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { useVerifyEmailPending } from './VerifyEmailPendingPage.logic'

export function VerifyEmailPendingPage() {
  const { t, user, isLoading, resendSuccess, handleResend, handleLogout } = useVerifyEmailPending()

  return (
    <div className="w-full max-w-md">
      <Card>
        <CardContent className="pt-6">
          <div className="flex flex-col items-center text-center">
            <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-primary/10">
              <Mail className="size-6 text-primary" />
            </div>
            <h3 className="mb-2 text-lg font-medium">{t('checkYourEmail')}</h3>
            <p className="mb-2 text-sm text-muted-foreground">{t('verificationEmailSent')}</p>
            {user?.email && <p className="mb-6 text-sm font-medium">{user.email}</p>}

            {resendSuccess && (
              <div className="mb-4 flex items-center gap-2 rounded-md bg-primary/10 px-4 py-2 text-sm text-primary">
                <CheckCircle2 className="size-4" />
                {t('verificationEmailResent')}
              </div>
            )}

            <div className="w-full space-y-3">
              <p className="text-sm text-muted-foreground">{t('didntReceiveEmail')}</p>
              <Button
                variant="outline"
                className="w-full"
                onClick={handleResend}
                disabled={isLoading}
              >
                {isLoading && <Loader2 className="animate-spin" />}
                {t('resendVerificationEmail')}
              </Button>

              <Button variant="ghost" className="w-full" onClick={handleLogout}>
                <LogOut className="size-4" />
                {t('logout')}
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
